/**
 * Mirror of functions-new/src/shared/teachingPlanConfig.ts
 */
export const ROUTINE_TIMETABLE_NC_STATUSES = ['two_to_three_below', 'four_or_more_below'];
